import React from "react";

export default props => {
  return (
    <button
      className="btn btn-primary animated zoomIn"
      style={{ marginTop: "50px" }}
      onClick={props.onClick}
    >
      <i className="material-icons">done</i>Continue
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/ContinueButton.js